'use strict';

import errorReportConfirmationTemplate from './views/errorReportConfirmation.hbs';
import errorReportFailureTemplate from './views/errorReportFailure.hbs';
import jQuery from 'jquery';

var PageNotFoundPage = (function($) {
  return function(options) {

    // Namespace for private variables and functions
    var privateNS = {
      defaults: { // Namespace for default options
      }
    };

    // Namespace for public variables and functions
    var publicNS = {};

    /**
     * Construct a new instance
     */
    privateNS.init = function() {
      // Initialize options
      privateNS.options = $.extend({}, privateNS.defaults, options);

      // Create a reference to the UI container
      privateNS.$container = $(privateNS.options.container);

      // Add event handlers to the UI controls
      privateNS.attachHandlers();

      // Return the public namespace
      return publicNS;
    };

    privateNS.onReportingClick = function(event) {

      // Cancel the default click event
      event.preventDefault();

      // Get the link that was clicked
      var $target = $(event.target);

      return $.ajax({
        url: window.themosis.ajaxurl, // Global access to the WordPress ajax handler file
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'ErrorPage.reportPageNotFound',
          error_url: location.href
        }
      }).then(function(data) {

        // If the returned status is true, show a confirmation message
        if (typeof data.status !== 'undefined' && data.status === true) {
          privateNS.$container.find('.error-reporting').html(errorReportConfirmationTemplate());
        } else {

          // If the report failed to send, show a failure message
          privateNS.$container.find('.error-reporting').html(errorReportFailureTemplate());
        }
      });

    };

    /**
     * Attach the event handlers for the series / episode page
     */
    privateNS.attachHandlers = function() {

      privateNS.$container.on(
        'click',
        '.reporting-link',
        privateNS.onReportingClick
      );

    };

    // Return a new instance
    return privateNS.init();
  };

})(jQuery);

export default PageNotFoundPage